module.exports = __webpack_public_path__ + "static/UAmobSlide3-6de8257513f04ed1bf1ecb0ab62f47a8.jpg";